import {
  Button,
  Grid,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import {
  Block,
  ExpandMore,
  KeyboardArrowRight,
  Print,
  Save,
} from "@material-ui/icons";
import Config, { CHECK_DISCOUNT } from "app/appConfig";
import CommonButton from "app/common/Component/Button/CommonButton";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import PopupForm from "app/common/Component/Popup/PopupForm";
import GlobitsCheckBox from "app/common/form/GlobitsCheckBox";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import GlobitsNumberInput from "app/common/form/GlobitsNumberInput";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsSelectInput from "app/common/form/GlobitsSelectInput";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import GlobitsVNDCurrencyInput from "app/common/form/GlobitsVNDCurrencyInput";
import GlobitsVNDCurrencyInputOnlyChange from "app/common/form/GlobitsVNDCurrencyInputOnlyChange";
import useDefaultDepartment from "app/common/hooks/useDefaultDepartment";
import IconCancel from "app/common/Icon/IconCancel";
import IconUserEdit from "app/common/Icon/IconUserEdit";
import {
  LAVoucherItemRevenueType,
  PAGESIZE_ALL,
  PathModule,
  PAYMENT_METHOD_CHARACTERISTIC_HOME_CREDIT,
  PAYMENT_METHOD_CHARACTERISTIC_POS,
  PAYMENT_METHOD_CHARACTERISTIC_POS_VNPAY_TRAGOP,
  PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT,
  PromotionTypeEnum,
  TYPE_GLOBAL_PROPOTIES_BANK,
  TYPE_GLOBAL_PROPOTIES_HOME_CREDIT_CODE,
  TYPE_GLOBAL_PROPOTIES_POS_LIST,
  TYPE_GLOBAL_PROPOTIES_POS_VNPAY_TRAGOP,
} from "app/common/LocalConst";
import {
  checkPaymentMethodLimits,
  format2NumberAtferComma,
  formatMoney,
  getDepartmentsUser,
  getDateTime,
  getPositionCodes,
  isAdmin,
  isRoleEditRevenueType,
  transformDate,
  validateEqualsSourceDiffirentTelesale,
  validateMaxTotalAmountTelesale,
  validateMaxTotalDiffTelesale,
  validateSelectDiffirentTelesale,
  validateSelectTelesale,
  validateVoucherPaymentMethods,
} from "app/common/LocalFunction";
import { renderOptionsStaff } from "app/PatientManagement/ReportSalesAllocation/ReportSalesAllocationSearch";
import { pagingDepartment } from "app/services/DepartmentService";
import { pagingExtGlobalProperty } from "app/services/GlobalPropertyService";
import { pagingStaff } from "app/services/StaffService";
import { useStore } from "app/stores";
import { getIn, useFormikContext } from "formik";
import { observer } from "mobx-react";
import { forwardRef, memo, useEffect, useState } from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import * as Yup from "yup";
import ButtonDeleteProgram from "../Component/ButtonDeleteProgram";
import TotalOfVoucherBy from "../Component/TotalOfVoucherBy";
import PrintPopupTemporary from "./PrintPopupTemporary";
import PrintPopupTheService from "./PrintPopupTheService";
import PromotionPaymentPopup from "./PromotionPaymentPopup";
import StaffRevenueFeePopup from "./StaffRevenueFeePopup";

const ServiceFeePopup = ({
  open,
  handleClose,
  data,
  handleAfterSubmit,
  isAdminPermission,
  departmentsUser,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  const {
    resetStorePopup,
    listPaymentMethod,
    listStk,
    listPos,
    listPos_tragop,
    listHomecredit,
    handleCreateVoucherAndUpdateToCrm,
    getListProperties,
  } = useStore().feeStore.serviceFeeTabStore;

  const defaultDepartment = useDefaultDepartment();
  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");
  useEffect(() => {
    getListProperties({
      departmentIds: defaultDepartment ? [defaultDepartment.id] : [],
    });
    return () => resetStorePopup();
  }, []);

  const validationItemsSchema = Yup.array().of(
    Yup.object().shape({
      currentPaymentAmount: Yup.number().test(
        "is-greater-than-zero",
        "Số tiền phải lớn hơn 0",
        function (value) {
          const { checked } = this.parent;
          return !checked || value > 0;
        },
      ),
    }),
  );

  const validationSchema = Yup.object().shape({
    accountant: Yup.object().required("Vui lòng chọn người lập").nullable(),
    voucherDate: Yup.date()
      .transform(function (_, originalValue) {
        if (!originalValue) return null;
        if (Array.isArray(originalValue) && originalValue.length >= 3) {
          return moment([
            originalValue[0],
            originalValue[1] - 1,
            originalValue[2],
            originalValue[3] || 0,
            originalValue[4] || 0,
            originalValue[5] || 0,
          ]).toDate();
        }
        return moment(originalValue).toDate();
      })
      .typeError("Ngày thu chưa đúng định dạng!")
      .nullable()
      .required("Bạn chưa chọn ngày lập!")
      .test(
        "is-after-registration-date",
        "Ngày lập không được nhỏ hơn ngày đăng ký gần nhất!",
        function (value) {
          if (!value) return true;
          const { services, products, treatmentCards, prepaidCards } =
            this.parent;
          let latestDate = null;

          const checkItems = (category) => {
            if (category && category.items && category.items.length > 0) {
              category.items.forEach((item) => {
                let dStr = item.invoiceDate;
                if (item.checked && dStr) {
                  // format array to work seamlessly with moment: [yyyy, m, d, hh, mm, ss]
                  let d;
                  if (Array.isArray(dStr) && dStr.length >= 3) {
                    d = moment([
                      dStr[0],
                      dStr[1] - 1,
                      dStr[2],
                      dStr[3] || 0,
                      dStr[4] || 0,
                      dStr[5] || 0,
                    ]);
                  } else {
                    d = moment(dStr);
                  }

                  if (d.isValid()) {
                    if (!latestDate || d.isAfter(latestDate)) {
                      latestDate = d;
                    }
                  }
                }
              });
            }
          };

          checkItems(services);
          checkItems(products);
          checkItems(treatmentCards);
          checkItems(prepaidCards);

          if (latestDate) {
            let voucherDate = moment(value);
            return voucherDate.isSameOrAfter(latestDate);
          }
          return true;
        },
      ),

    department: Yup.object().required("Vui lòng chọn cơ sở").nullable(),
    voucherPaymentMethods: Yup.array().of(
      Yup.object()
        .shape()
        .test(
          "Validate voucher bank",
          "Bắt buộc chọn stk",
          validateVoucherPaymentMethods,
        ),
    ),
    services: Yup.object().shape({
      items: validationItemsSchema,
    }),
    products: Yup.object().shape({
      items: validationItemsSchema,
    }),
    treatmentCards: Yup.object().shape({
      items: validationItemsSchema,
    }),
    prepaidCards: Yup.object().shape({
      items: validationItemsSchema,
    }),
  });
  return (
    <PopupForm
      open={open}
      size="xxl"
      height="75vh"
      handleClose={handleClose}
      title={"Thanh toán dịch vụ/sản phẩm"}
      formik={{
        initialValues: {
          ...data,
          department: data?.department ? data?.department : defaultDepartment,
        },
        onSubmit: async (values, { setSubmitting }) => {
          await handleCreateVoucherAndUpdateToCrm(values, {
            setSubmitting,
            handleAfterSubmit,
          });
        },
        validationSchema,
        enableReinitialize: true,
      }}
      action={({ isSubmitting, values, submitForm, setFieldValue }) => {
        return (
          <div className="flex-center gap-1">
            {/* <CommonButton
              // type="submit"
              disabled={isSubmitting}
              onClick={async () => {
                setFieldValue("isCreateBill", true);
                await submitForm();
              }}
            >
              {!isMobile && <MoneyOffOutlined className="mr-2 " />}
              Tạo bill tạm tính
            </CommonButton> */}
            {/* <PrintButton
              isSubmitting={isSubmitting}
              values={values}
              isMobile={isMobile}
              listPaymentMethod={listPaymentMethod}
            /> */}

            <CommonButton
              disabled={isSubmitting}
              onClick={async () => {
                setFieldValue("isCreateBill", false);
                await submitForm();
              }}
            >
              {!isMobile && <Save className="mr-2 " />}
              Thanh toán
            </CommonButton>

            <CommonButton className="btn-gray" onClick={handleClose}>
              <Block className="mr-2" /> Đóng
            </CommonButton>
          </div>
        );
      }}
    >
      {({ setFieldValue, values }) => {
        return (
          <>
            <ValueForm
              listPaymentMethod={listPaymentMethod}
              listStk={listStk}
              listPos={listPos}
              listPos_tragop={listPos_tragop}
              listHomecredit={listHomecredit}
              patientId={patientId}
              isAdminPermission={isAdminPermission}
              departmentsUser={departmentsUser}
            />
            <DialogError patientId={patientId} setFieldValue={setFieldValue} />
          </>
        );
      }}
    </PopupForm>
  );
};

const ValueForm = observer(
  ({
    listPaymentMethod,
    listStk,
    listPos,
    listHomecredit,
    listPos_tragop,
    patientId,
    isAdminPermission,
    departmentsUser,
  }) => {
    const { values, setFieldValue } = useFormikContext();
    const [open, setOpen] = useState(false);

    // TUYỆT VỌNG LẮM MỚI VIẾT CODE NHƯ NÀY ,NHƯNG HẾT CÁCH GÒI ,BỘ NÃO TUI CÓ GIỚI HẠN ,
    // ĐỪNG ĐÚM TUI

    const handleCalculateRemaining = (el) => {
      let beforeTax;
      let tax;
      let aftefTax;

      if (el?.priceWithTax) {
        aftefTax = el?.currentFee * el?.quantity - el?.discount;
        tax =
          (aftefTax / (100 + +el?.surchargePercent || 0)) *
          (+el?.surchargePercent || 0);
        beforeTax = (aftefTax / (100 + +el?.surchargePercent || 0)) * 100;
      } else {
        beforeTax = el?.currentFee * el?.quantity - el?.discount;
        tax = (beforeTax * (el?.surchargePercent || 0)) / 100;
        aftefTax = beforeTax + tax;
      }

      let remaining =
        aftefTax -
        // (el?.currentAllocateDiscount || 0) -
        el?.subTotalBillPatientPaid; // con lai
      return remaining;
    };

    const handleChangePaymentMethodSelect = (e) => {
      let paymentMethodSelect = e.target.checked;
      setFieldValue("paymentMethodSelect", paymentMethodSelect);
      let totalAmount = 0;
      let services;
      let products;
      let prepaidCards;
      let treatmentCards;
      if (paymentMethodSelect) {
        services = values?.services?.items?.map((el) => {
          let remainingService = handleCalculateRemaining(el);
          totalAmount += remainingService;
          return {
            ...el,
            currentPaymentAmount: remainingService,
            checked: true,
          };
        });

        products = values?.products?.items?.map((el) => {
          let remainingProduct = handleCalculateRemaining(el);

          totalAmount += remainingProduct;

          return {
            ...el,
            currentPaymentAmount: remainingProduct,
            checked: true,
          };
        });

        prepaidCards = values?.prepaidCards?.items?.map((el) => {
          let remainingPayment = handleCalculateRemaining(el);

          totalAmount += remainingPayment;

          return {
            ...el,
            currentPaymentAmount: remainingPayment,
            checked: true,
          };
        });
        treatmentCards = values?.treatmentCards?.items?.map((el) => {
          let remaininCard = handleCalculateRemaining(el);

          totalAmount += remaininCard;

          return {
            ...el,
            currentPaymentAmount: remaininCard,
            checked: true,
          };
        });
      } else {
        services = values?.services?.items?.map((el) => {
          return {
            ...el,
            checked: false,
          };
        });

        products = values?.products?.items?.map((el) => {
          return {
            ...el,
            checked: false,
          };
        });

        prepaidCards = values?.prepaidCards?.items?.map((el) => {
          return {
            ...el,
            checked: false,
          };
        });
        treatmentCards = values?.treatmentCards?.items?.map((el) => {
          return {
            ...el,
            checked: false,
          };
        });
      }
      setFieldValue("services.items", services);
      setFieldValue("products.items", products);
      setFieldValue("prepaidCards.items", prepaidCards);
      setFieldValue("treatmentCards.items", treatmentCards);
      setFieldValue("totalAmount", totalAmount);
      setFieldValue("moneyAfterDiscount", totalAmount - values?.discount);
    };

    const handleChangeAllocatable = (value) => {
      // if (value > values?.totalAmount) {
      //   toast.warning(
      //     "Không thể nhập số tiền giảm lớn hơn tổng số tiền cần thanh toán!"
      //   );
      //   setFieldValue("discount", 0);
      //   return;
      // }
      let { products, prepaidCards, services, treatmentCards } = values;

      // Trộn toàn bộ item lại và giữ chỉ số để phân lại sau
      const allItems = [
        ...(services?.items || []),
        ...(products?.items || []),
        ...(prepaidCards?.items || []),
        ...(treatmentCards?.items || []),
      ];

      const validItems = allItems
        .map((item, index) => ({
          ...item,
          _index: index,
          currentAllocateDiscount: 0,
        }))
        .filter((item) => item.checked && item.currentPaymentAmount > 0);

      let remaining = value;

      while (remaining > 0) {
        // Tìm tất cả item còn room
        const itemsWithRoom = validItems.filter(
          (item) =>
            item.currentPaymentAmount - item.currentAllocateDiscount > 0,
        );

        if (itemsWithRoom.length === 0) break; // hết room

        // Chia đều cho số item còn room
        let remainingPerItem =
          Math.floor(remaining / itemsWithRoom.length / 1000) * 1000;

        if (remainingPerItem === 0) {
          break;
        } else {
          for (let item of itemsWithRoom) {
            const canAdd =
              item.currentPaymentAmount - item.currentAllocateDiscount;
            const step = Math.min(remainingPerItem, canAdd);
            item.currentAllocateDiscount += step;
            remaining -= step;
          }
        }
      }

      if (remaining > 0) {
        const itemToAdd = validItems.find(
          (item) =>
            item.currentPaymentAmount - item.currentAllocateDiscount > 0,
        );
        if (itemToAdd) {
          const canAdd =
            itemToAdd.currentPaymentAmount - itemToAdd.currentAllocateDiscount;
          const finalStep = Math.min(canAdd, remaining);
          itemToAdd.currentAllocateDiscount += finalStep;
          remaining -= finalStep;
        }
      }

      // Gán lại dữ liệu cho allItems theo index
      const updatedItems = allItems.map((item, idx) => {
        const found = validItems.find((v) => v._index === idx);
        return {
          ...item,
          currentAllocateDiscount: found ? found.currentAllocateDiscount : 0,
        };
      });

      // Phân lại ra từng mảng gốc
      const sLength = services?.items?.length || 0;
      const pLength = products?.items?.length || 0;
      const prLength = prepaidCards?.items?.length || 0;
      // const tLength = treatmentCards?.items?.length || 0;

      setFieldValue("services.items", updatedItems.slice(0, sLength));
      setFieldValue(
        "products.items",
        updatedItems.slice(sLength, sLength + pLength),
      );
      setFieldValue(
        "prepaidCards.items",
        updatedItems.slice(sLength + pLength, sLength + pLength + prLength),
      );
      setFieldValue(
        "treatmentCards.items",
        updatedItems.slice(sLength + pLength + prLength),
      );
    };

    const handleChangePercentDiscount = (e) => {
      let percentDiscount = e?.target?.value;
      let discount = +(percentDiscount * values?.totalAmount) / 100;
      let totalAmount = values?.totalAmount;

      setFieldValue("moneyAfterDiscount", totalAmount - discount);
      setFieldValue("percentDiscount", percentDiscount);
      setFieldValue("discount", discount);
      handleChangeAllocatable(discount);
    };

    const handleChangeDiscount = (discount) => {
      let percentDiscount = discount / values?.totalAmount;

      let totalAmount = values?.totalAmount;
      // if (discount > totalAmount) {
      //   toast.warning(
      //     "Không thể nhập số tiền giảm lớn hơn tổng số tiền cần thanh toán!"
      //   );
      //   setFieldValue("discount", 0);
      //   return;
      // }
      setFieldValue("percentDiscount", percentDiscount);
      setFieldValue("moneyAfterDiscount", totalAmount - discount);
      setFieldValue("discount", discount);
      handleChangeAllocatable(discount);
    };

    const getListProperties = async () => {
      return await pagingExtGlobalProperty({
        pageIndex: 1,
        pageSize: PAGESIZE_ALL,
        isActive: true,
      })
        .then(({ data }) => {
          if (data?.content?.length > 0) {
            const listStk = data?.content?.filter(
              (el) => el?.dataType === TYPE_GLOBAL_PROPOTIES_BANK,
            );
            const listPos = data?.content?.filter(
              (el) => el?.dataType === TYPE_GLOBAL_PROPOTIES_POS_LIST,
            );
            const listHomecredit = data?.content?.filter(
              (el) => el?.dataType === TYPE_GLOBAL_PROPOTIES_HOME_CREDIT_CODE,
            );

            const listPos_tragop = data?.content?.filter(
              (el) => el?.dataType === TYPE_GLOBAL_PROPOTIES_POS_VNPAY_TRAGOP,
            );

            return {
              listStk,
              listPos,
              listHomecredit,
              listPos_tragop,
            };
          } else {
            return {
              listStk: [],
              listPos: [],
              listHomecredit: [],
              listPos_tragop: [],
            };
          }
        })
        .catch((error) => {
          console.error(error);
          toast.error("Lấy dữ liệu hình thức thanh toán có lỗi");
        });
    };

    return (
      <>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid
              container
              spacing={1}
              style={{ backgroundColor: "aliceblue" }}
            >
              <Grid item xs={12} md={2}>
                <GlobitsPagingAutocomplete
                  label="Người lập"
                  name="accountant"
                  displayLabel="staffName"
                  api={pagingStaff}
                  required
                  searchObject={{
                    isActive: true,
                    //excludeStatus: EXCLUDE_QUIT_STAFF
                  }}
                  ListboxComponent={forwardRef((props, ref) => {
                    const { children, ...other } = props;
                    return (
                      <ul {...other} ref={ref}>
                        <ol>
                          <li>{children}</li>
                        </ol>
                      </ul>
                    );
                  })}
                  renderOption={(option) => renderOptionsStaff(option)}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <GlobitsDateTimePicker
                  required
                  label="Ngày lập"
                  name="voucherDate"
                  isDateTimePicker
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsPagingAutocomplete
                  name={"department"}
                  label={"Cơ sở"}
                  api={
                    isAdminPermission
                      ? pagingDepartment
                      : async () => ({
                          data: {
                            content: departmentsUser || [],
                            totalElements: departmentsUser?.length || 0,
                            totalPages: 1,
                          },
                        })
                  }
                  required
                  onChange={async (_, department) => {
                    setFieldValue("department", department);
                    const { listStk, listPos, listHomecredit, listPos_tragop } =
                      await getListProperties({
                        departmentIds: department ? [department.id] : [],
                      });
                    let voucherPaymentMethods =
                      values?.voucherPaymentMethods?.map((el) => {
                        if (
                          el?.paymentMethodValue?.characteristic ===
                          PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT
                        ) {
                          return {
                            ...el,
                            bankName: listStk?.[0]?.propertyName,
                            bankAccountNumber: listStk?.[0]?.property,
                            paymentBank: listStk?.[0],
                          };
                        }
                        if (
                          el?.paymentMethodValue?.characteristic ===
                          PAYMENT_METHOD_CHARACTERISTIC_POS
                        ) {
                          return {
                            ...el,
                            bankName: listPos?.[0]?.propertyName,
                            bankAccountNumber: listPos?.[0]?.property,
                            paymentBank: listPos?.[0],
                          };
                        }
                        if (
                          el?.paymentMethodValue?.characteristic ===
                          PAYMENT_METHOD_CHARACTERISTIC_POS_VNPAY_TRAGOP
                        ) {
                          return {
                            ...el,
                            bankName: listPos_tragop?.[0]?.propertyName,
                            bankAccountNumber: listPos_tragop?.[0]?.property,
                            paymentBank: listPos_tragop?.[0],
                          };
                        }
                        if (
                          el?.paymentMethodValue?.characteristic ===
                          PAYMENT_METHOD_CHARACTERISTIC_HOME_CREDIT
                        ) {
                          return {
                            ...el,
                            bankName: listHomecredit?.[0]?.propertyName,
                            bankAccountNumber: listHomecredit?.[0]?.property,
                            paymentBank: listHomecredit?.[0],
                          };
                        }
                        return el;
                      });
                    setFieldValue(
                      "voucherPaymentMethods",
                      voucherPaymentMethods,
                    );
                  }}
                />
              </Grid>

              <Grid item xs={12} md={2} className="flex-center">
                <GlobitsCheckBox
                  label="Thanh toán hết"
                  name="paymentMethodSelect"
                  onChange={handleChangePaymentMethodSelect}
                />
              </Grid>
              <Grid item xs={12} md={2} className="flex-center">
                <GlobitsCheckBox
                  label="Không tự động tích điểm"
                  name="noAutoAccumulatePoints"
                />
              </Grid>

              {values?.totalRemaningDeposit >= 0 && (
                <Grid item xs={12} md={2} className="flex-center">
                  <span>
                    Tiền cọc còn lại:{formatMoney(values?.totalRemaningDeposit)}
                  </span>
                </Grid>
              )}
              {values?.totalRemaningCard >= 0 && (
                <Grid item xs={12} md={2} className="flex-center">
                  <span>
                    Tiền thẻ còn lại:{formatMoney(values?.totalRemaningCard)}
                  </span>
                </Grid>
              )}
              <Grid item xs={12} md={2} className="flex-end pb-1">
                <PromotionProgram
                  setFieldValue={setFieldValue}
                  initialValues={values}
                  handleChangeDiscount={handleChangeDiscount}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={"auto"} style={{ zoom: "0.8", width: "80%" }}>
            {!values?.services &&
              !values?.products &&
              !values?.prepaidCards &&
              !values?.treatmentCards && (
                <div
                  className="flex-center"
                  style={{ height: "100%", fontSize: "20px" }}
                >
                  Không có dữ liệu
                </div>
              )}
            {values?.services?.items?.length > 0 && (
              <Items
                handleChangeAllocatable={handleChangeAllocatable}
                nameSpace="services"
                data={values?.services}
                title="dịch vụ"
              />
            )}
            {values?.products?.items?.length > 0 && (
              <Items
                nameSpace="products"
                data={values?.products}
                title="sản phẩm"
                handleChangeAllocatable={handleChangeAllocatable}
              />
            )}
            {values?.prepaidCards?.items?.length > 0 && (
              <Items
                nameSpace="prepaidCards"
                data={values?.prepaidCards}
                title="thẻ trả trước"
                handleChangeAllocatable={handleChangeAllocatable}
              />
            )}
            {values?.treatmentCards?.items?.length > 0 && (
              <Items
                nameSpace="treatmentCards"
                data={values?.treatmentCards}
                title="liệu trình"
                handleChangeAllocatable={handleChangeAllocatable}
              />
            )}
          </Grid>
          <Grid item xs={12} md={"auto"} style={{ width: "20%" }}>
            <Grid container spacing={1} className="w-100 m-0">
              {values?.promotionProgramCode && (
                <Grid item xs={12} className="flex-between flex align-center">
                  <b style={{ fontWeight: "500", fontSize: "12px" }}>
                    Chương trình khuyến mãi:
                  </b>
                  <span
                    className="text-red flex align-center gap-1"
                    style={{ fontWeight: "500", fontSize: "10px" }}
                  >
                    <DialogConfirmPromotion setFieldValue={setFieldValue} />
                    {values?.promotionProgramCode}
                  </span>
                </Grid>
              )}
              <Grid item xs={12} className="flex-between">
                <b>Tổng thanh toán:</b>
                <span className="text-blue" style={{ fontWeight: "600" }}>
                  {formatMoney(values?.totalAmount)}
                </span>
              </Grid>

              {values?.methodDiscount && (
                <Grid item xs={12} md={6}>
                  <GlobitsNumberInput
                    decimal
                    label="% giảm giá"
                    name="percentDiscount"
                    onChange={(event) => handleChangePercentDiscount(event)}
                  />
                </Grid>
              )}
              {CHECK_DISCOUNT && !values?.methodDiscount && (
                <Grid item xs={12} md={6}>
                  <GlobitsVNDCurrencyInputOnlyChange
                    isOnlyOnChange
                    label="Số tiền được giảm"
                    maxValue={values?.totalAmount}
                    name="discount"
                    onChange={(event) => {
                      const discount = +event.target.value;
                      handleChangeDiscount(discount);
                    }}
                    disabled
                  />
                </Grid>
              )}
              {values?.promotionProgram && (
                <Grid item xs={12}>
                  <div class="promo-wrapper">
                    <span class="promo-delete">
                      <ButtonDeleteProgram
                        setFieldValue={setFieldValue}
                        values={values}
                        handleChangeDiscount={handleChangeDiscount}
                      />
                    </span>
                    <span class="promo-text flex-1">
                      CTKM đã chọn: {values?.promotionProgram?.name}
                    </span>
                  </div>
                </Grid>
              )}
              {/* <Grid item xs={6} className="flex-center">
                <GlobitsCheckBox
                  label="Giảm theo %"
                  name="methodDiscount"
                  onChange={(e) => {
                    let methodDiscount = e.target.checked;
                    setFieldValue("methodDiscount", methodDiscount);
                    if (methodDiscount) {
                      setFieldValue("discount", 0);
                    } else {
                      setFieldValue("percentDiscount", 0);
                    }
                  }}
                />
              </Grid> */}

              <Grid
                item
                xs={12}
                className="flex-between align-center"
                style={{ borderTop: "1px dashed #4276a4" }}
              >
                <b>Cần thu: </b>
                <span className="text-danger" style={{ fontWeight: "600" }}>
                  {formatMoney(values?.moneyAfterDiscount)}
                </span>
              </Grid>

              <Grid item xs={12} md={12}>
                <TotalOfVoucherBy
                  nameSpace={"voucherPaymentMethods"}
                  listPaymentMethod={listPaymentMethod}
                  listStk={listStk}
                  listPos={listPos}
                  listHomecredit={listHomecredit}
                  listPos_tragop={listPos_tragop}
                  moneyAfterDiscount={values?.moneyAfterDiscount}
                  patientId={patientId}
                />
              </Grid>
              <Grid item xs={12}>
                <GlobitsTextField
                  name="note"
                  label="Nội dung"
                  isTextArea
                  rows={3}
                />
              </Grid>
              <Grid item xs={12}>
                <p
                  className="flex-inline align-center text-primary text-toggle uppercase pointer"
                  onClick={() => {
                    setOpen(!open);
                    if (!open) {
                      setFieldValue("eInvoiceIssuedDate", new Date());
                    } else {
                      setFieldValue("eInvoiceIssuedDate", null);
                    }
                  }}
                >
                  {!open ? <KeyboardArrowRight /> : <ExpandMore />} Hóa đơn
                </p>
              </Grid>
              {open && (
                <>
                  <Grid item xs={6}>
                    <GlobitsTextField
                      name="eInvoiceCode"
                      label="Mã hóa đơn điện tử"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <GlobitsDateTimePicker
                      name="eInvoiceIssuedDate"
                      label="Ngày xuất"
                      isDateTimePicker
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  },
);

const Items = ({ data, title, nameSpace, handleChangeAllocatable }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(true);
  const [dataRevenue, setDataRevenue] = useState(null);
  const { values, setFieldValue } = useFormikContext();

  const handleAllocataStaff = () => {
    let dataGroupSv = getIn(values, nameSpace);
    let formatItem = dataGroupSv?.items?.reduce((acc, el) => {
      if (el?.checked) {
        let totalDetail =
          (+el?.currentPaymentAmount || 0) -
          (+el?.currentAllocateDiscount || 0); // tổng tiền thu

        let staffRevenuesFormat = el?.staffRevenues?.map((staff) => ({
          ...staff,
          actualAmount: (totalDetail * staff?.percentRevenue) / 100,
          notDefaultSubmit: true, // đánh dấu nếu đã tự chọn phân bổ rồi thì ko tự phân bổ lại khi submit nữa
        }));

        acc.push({
          ...el,
          staffRevenues: staffRevenuesFormat,
          totalDetail,
        });
      }
      return acc;
    }, []);
    setDataRevenue({
      list: { ...dataGroupSv, items: formatItem },
      title,
      nameSpace,
    });
  };

  return (
    <Grid item sm={12}>
      <p className="flex-inline align-center text-second uppercase pointer">
        <span onClick={() => setOpen(!open)}>
          {!open ? <KeyboardArrowRight /> : <ExpandMore />} {title}
        </span>
        <span onClick={handleAllocataStaff}>
          <IconUserEdit width="20" className="ml-2" color="#4276a4" />
        </span>
      </p>
      {open && (
        <div
          style={{
            overflow: "auto",
            scrollbarWidth: "thin",
          }}
          className="table-root"
        >
          <div style={{ minWidth: "1000px" }}>
            <table className="table-container table-collapse table-layout-fixed">
              <thead className="row-table-header">
                <tr className="row-table-header">
                  <th width="20" align="center">
                    <strong>STT</strong>
                  </th>
                  <th width="20">
                    <input
                      type="checkbox"
                      style={{ width: "16px", height: "16px" }}
                      checked={
                        data?.items?.length > 0 &&
                        data?.items?.every((el) => el?.checked)
                      }
                      onChange={(e) => {
                        let oldTotalAmountItems =
                          data?.items?.length > 0 &&
                          data?.items?.reduce((acc, curr) => {
                            if (curr?.checked) {
                              return acc + curr?.currentPaymentAmount;
                            }
                            return acc;
                          }, 0);
                        let newData = data?.items?.map((el) => ({
                          ...el,
                          checked: e?.target?.checked,
                        }));
                        let newTotalAmountItems =
                          newData?.length > 0 &&
                          newData?.reduce((acc, curr) => {
                            if (curr?.checked) {
                              return acc + curr?.currentPaymentAmount;
                            }
                            return acc;
                          }, 0);

                        setFieldValue(`${nameSpace}.items`, newData);
                        let totalAmount =
                          values?.totalAmount -
                          oldTotalAmountItems +
                          newTotalAmountItems;
                        setFieldValue("totalAmount", totalAmount);
                        setFieldValue(
                          "moneyAfterDiscount",
                          totalAmount - values?.discount,
                        );
                      }}
                    />
                  </th>

                  <th width="80">
                    <strong>Tên {title}</strong>
                  </th>

                  <th width="35">
                    <strong>Chiết khẩu</strong>
                  </th>

                  <th width="45">
                    <strong>Ngày đăng kí</strong>
                  </th>

                  <th width="20">
                    <strong>% Thuế</strong>
                  </th>

                  <th width="65">
                    <strong>Tạm tính</strong>
                  </th>
                  <th width="50">
                    <strong>Đã giảm theo tổng bill</strong>
                  </th>

                  <th width="60">
                    <strong>Thanh toán</strong>
                  </th>

                  <th width="50">
                    <strong>Thu hiện thời</strong>
                  </th>

                  <th width="80" colSpan={1}>
                    <strong>Loại doanh thu</strong>
                  </th>
                  <th width="80" colSpan={1}>
                    <strong>Giảm giá</strong>
                  </th>

                  {/* <th width="50">
                    <strong>Phân bổ</strong>
                    <Tooltip title="Phân bổ lại">
                      <IconButton
                        // className="btn-add"
                        style={{ color: "#ff8480" }}
                        onClick={() => {
                          // if (values?.discount) {
                          handleChangeAllocatable(values?.discount);
                          // }
                        }}
                      >
                        <LoopIcon />
                      </IconButton>
                    </Tooltip>
                  </th> */}
                  <th width="110" colSpan={2}>
                    <strong>Chi tiết</strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                {data?.items?.length > 0 ? (
                  <>
                    {data?.items?.map((item, itemIndex) => {
                      let totalDetail =
                        (+item?.currentPaymentAmount || 0) -
                        (item?.currentAllocateDiscount || 0); // tong tien thu
                      let surchargeDetail =
                        item?.surchargePercent || 0
                          ? (totalDetail / (100 + +item?.surchargePercent)) *
                            (+item?.surchargePercent || 0)
                          : 0;

                      let amountDetail =
                        (totalDetail / (100 + (item?.surchargePercent || 0))) *
                        100; //thanh tien phieu thu

                      let beforeTax;
                      let tax;
                      let aftefTax;

                      if (item?.priceWithTax) {
                        aftefTax =
                          item?.currentFee * item?.quantity - item?.discount;
                        tax =
                          (aftefTax / (100 + +item?.surchargePercent || 0)) *
                          (+item?.surchargePercent || 0);
                        beforeTax =
                          (aftefTax / (100 + (+item?.surchargePercent || 0))) *
                          100;
                      } else {
                        beforeTax =
                          item?.currentFee * item?.quantity - item?.discount; // truoc thue
                        tax = (beforeTax * (item?.surchargePercent || 0)) / 100;
                        aftefTax = beforeTax + tax;
                      }

                      let remaining =
                        aftefTax -
                        item?.allocateDiscount -
                        item?.subTotalBillPatientPaid; // con lai

                      return (
                        <>
                          <tr key={`item-${itemIndex}`}>
                            <td align="center">{itemIndex + 1}</td>
                            <td align="center">
                              <input
                                type="checkbox"
                                style={{ width: "16px", height: "16px" }}
                                checked={item?.checked}
                                onChange={(e) => {
                                  let checked = e?.target?.checked;
                                  setFieldValue(
                                    `${nameSpace}.items[${itemIndex}].checked`,
                                    checked,
                                  );

                                  let totalAmount;

                                  if (e?.target?.checked) {
                                    totalAmount =
                                      values?.totalAmount +
                                      item?.currentPaymentAmount;
                                    setFieldValue("totalAmount", totalAmount);
                                  } else {
                                    totalAmount =
                                      values?.totalAmount -
                                      item?.currentPaymentAmount;
                                    setFieldValue("totalAmount", totalAmount);
                                  }
                                  setFieldValue(
                                    "moneyAfterDiscount",
                                    totalAmount - values.discount,
                                  );
                                }}
                              />
                            </td>
                            <td align="">
                              <b>
                                {item?.patientServiceRegister?.service
                                  ?.tradeName || item?.invoiceItemName}
                              </b>
                              <div>
                                SL: <b>{item?.quantity} *</b>{" "}
                                {format2NumberAtferComma(item?.currentFee)}
                              </div>
                            </td>

                            <td align="right">
                              {format2NumberAtferComma(item?.discount)}
                            </td>
                            <td align="right">
                              {getDateTime(item?.invoiceDate)}
                            </td>
                            <td align="right">{item?.surchargePercent}</td>
                            <td align="right">
                              <div>
                                {" "}
                                Trước thuế:{" "}
                                <b>{format2NumberAtferComma(beforeTax)}</b>
                              </div>

                              <div>
                                {" "}
                                Thuế: <b>{format2NumberAtferComma(tax)}</b>
                              </div>
                              <div>
                                {" "}
                                Thành tiền:{" "}
                                <b>{format2NumberAtferComma(aftefTax)}</b>
                              </div>
                            </td>
                            <td align="right">
                              {format2NumberAtferComma(item?.allocateDiscount)}
                            </td>
                            <td align="left">
                              <div>
                                Đã thu:{" "}
                                <b>
                                  {format2NumberAtferComma(
                                    item?.subTotalBillPatientPaid,
                                  )}
                                </b>
                              </div>
                              <div>
                                Còn lại:{" "}
                                <b>{format2NumberAtferComma(remaining)}</b>
                                {/* Thành tiền (tạm tính) - Đã giảm/tổng bill - Đã thu */}
                              </div>
                            </td>

                            <td align="">
                              <GlobitsVNDCurrencyInput
                                name={`${nameSpace}.items[${itemIndex}].currentPaymentAmount`}
                                maxValue={remaining}
                                onChange={(e) => {
                                  let value = +e?.target?.value;
                                  setFieldValue(
                                    `${nameSpace}.items[${itemIndex}].currentPaymentAmount`,
                                    value,
                                  );
                                  if (item?.checked) {
                                    let dataOld = getIn(
                                      values,
                                      `${nameSpace}.items[${itemIndex}].currentPaymentAmount`,
                                    );

                                    setFieldValue(
                                      "totalAmount",
                                      values?.totalAmount - dataOld + value,
                                    );

                                    setFieldValue(
                                      "moneyAfterDiscount",
                                      values?.totalAmount -
                                        dataOld +
                                        value -
                                        values?.discount,
                                    );
                                  }
                                  if (value > remaining) {
                                    toast.warning(
                                      "Số tiền thu không được quá số tiền còn lại",
                                    );
                                  }
                                }}
                              />
                            </td>
                            <td>
                              <GlobitsSelectInput
                                name={`${nameSpace}.items[${itemIndex}].voucherItemRevenueType`}
                                options={LAVoucherItemRevenueType.getListData()}
                                disabled={!isAdmin() && !isRoleEditRevenueType()}
                              />
                            </td>
                            <td>
                              <GlobitsVNDCurrencyInputOnlyChange
                                isOnlyOnChange
                                name={`${nameSpace}.items[${itemIndex}].currentAllocateDiscount`}
                                disabled
                                onChange={(e) => {
                                  let currentAllocateDiscount =
                                    +e?.target?.value;

                                  if (
                                    currentAllocateDiscount >
                                    item?.currentPaymentAmount
                                  ) {
                                    toast.warning(
                                      "Không được nhập quá số tiền thu hiện thời",
                                    );

                                    return;
                                  }
                                  setFieldValue(
                                    `${nameSpace}.items[${itemIndex}].currentAllocateDiscount`,
                                    currentAllocateDiscount,
                                  );
                                }}
                              />
                            </td>
                            <td>
                              <div>Thành tiền phiếu thu: </div>
                              <div>VAT: </div>
                              <div>Tổng tiền thu: </div>
                            </td>
                            <td align="right">
                              <div>
                                <b>{format2NumberAtferComma(amountDetail)}</b>
                              </div>
                              <div>
                                <b>
                                  <b>
                                    {format2NumberAtferComma(surchargeDetail)}
                                  </b>
                                </b>
                              </div>
                              <div>
                                <b>{format2NumberAtferComma(totalDetail)}</b>
                              </div>
                            </td>
                          </tr>
                        </>
                      );
                    })}
                  </>
                ) : (
                  <tr className="row-table-body row-table-no_data">
                    <td colSpan={13} align="center">
                      {t("noData")}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {!!dataRevenue && (
        <StaffRevenueFeePopup
          open={!!dataRevenue}
          handleClose={() => setDataRevenue(null)}
          data={dataRevenue}
          handleSubmit={(dataAfterChange) => {
            let currentData = getIn(values, `${dataRevenue?.nameSpace}`); // data hiện tại
            let currentItems = getIn(values, `${dataRevenue?.nameSpace}.items`); //mảng items hiện tại
            let newData = dataAfterChange?.[dataRevenue?.nameSpace]?.items; //data mới
            let newItems = currentItems?.map((el, index) => {
              if (el?.checked) {
                return newData?.find((it) => it?.id === el?.id);
              } else {
                return el;
              }
            });
            setFieldValue(dataRevenue?.nameSpace, {
              ...currentData,
              items: newItems,
            });
            setDataRevenue(null);
          }}
        />
      )}
    </Grid>
  );
};

const PrintButton = observer(
  ({ isSubmitting, values, isMobile, listPaymentMethod }) => {
    const {
      printData,
      setPrintData,
      setOpenTemporaryInvoicePrintPopup,
      openTemporaryInvoicePrintPopup,
      openServiceInvoicePrintPopup,
      setOpenServiceInvoicePrintPopup,
    } = useStore().feeStore.serviceFeeTabStore;
    return (
      <>
        <CommonButton
          className="addNewButton"
          disabled={isSubmitting}
          onClick={async () => {
            await setPrintData(values);
            setOpenServiceInvoicePrintPopup(true);
          }}
        >
          {!isMobile && <Print className="mr-2 " />}
          In bill tạm tính
        </CommonButton>
        {openTemporaryInvoicePrintPopup && ( // tạo bill tạm
          <PrintPopupTemporary
            open={openTemporaryInvoicePrintPopup}
            handleClose={() => setOpenTemporaryInvoicePrintPopup(false)}
            selectedItems={printData?.items}
            qrCode={printData?.QRCode?.qrBankCode}
            voucherPaymentMethods={values?.voucherPaymentMethods}
            listInvoiceItems={printData?.listInvoiceItems}
          />
        )}
        {openServiceInvoicePrintPopup && ( // in bill tạm
          <PrintPopupTheService
            open={openServiceInvoicePrintPopup}
            handleClose={() => setOpenServiceInvoicePrintPopup(false)}
            selectedItems={printData?.items}
            qrCode={printData?.QRCode?.qrBankCode}
            voucherPaymentMethods={values?.voucherPaymentMethods}
          />
        )}
      </>
    );
  },
);

const PromotionProgram = observer(
  ({ initialValues, setFieldValue, handleChangeDiscount }) => {
    const {
      promotionPrograms,
      openFormFreePromotion,
      handleCloseFormFreePromotion,
      handleOpenFormFreePromotion,
    } = useStore().feeStore.serviceFeeTabStore;

    const allItems = [
      ...(initialValues?.services?.items || []),
      ...(initialValues?.products?.items || []),
      ...(initialValues?.prepaidCards?.items || []),
      ...(initialValues?.treatmentCards?.items || []),
    ];
    const dataFilter = allItems?.filter((item) => item?.checked);

    const dataCode = dataFilter?.map((el) => {
      if (el?.patientServiceRegister)
        return el?.patientServiceRegister?.service?.code;
      if (el?.drug) return el?.drug?.code;
      if (el?.treatmentPlanCard) return el?.treatmentPlanCard?.clientCard?.code;
    });
    const handleApplyPromotion = async (obj) => {
      if (obj?.promotionProgram) {
        if (
          obj?.promotionProgram?.promotionType ===
          PromotionTypeEnum.VOUCHER.value
        ) {
        }
      }

      let totalMoneyApply = 0;
      if (obj?.promotionProgram?.paymentMethodList?.length > 0) {
        totalMoneyApply = initialValues?.voucherPaymentMethods?.reduce(
          (acc, curr) => {
            const checkExitsValid =
              obj?.promotionProgram?.paymentMethodList?.length > 0 &&
              obj?.promotionProgram?.paymentMethodList.some(
                (el) => el?.code === curr?.paymentMethodValue?.code,
              );
            if (checkExitsValid) acc += +curr?.totalOfMethod || 0;
            return acc;
          },
          0,
        );
      } else {
        totalMoneyApply = initialValues?.moneyAfterDiscount;
      }

      const discountAll =
        obj?.promotionProgram?.allProductDiscountValue ||
        (obj?.promotionProgram?.allProductDiscountPercent * totalMoneyApply) /
          100;
      setFieldValue("promotionProgram", obj?.promotionProgram);
      handleChangeDiscount(discountAll);
      handleCloseFormFreePromotion();
    };

    return (
      <>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => {
            if (dataCode?.length > 0) {
              handleOpenFormFreePromotion({
                ...initialValues,
                listCode: dataCode,
              });
            } else {
              toast.warning("Vui lòng chọn dịch vụ");
            }
          }}
        >
          Chọn chương trình khuyến mãi
        </Button>

        {openFormFreePromotion && (
          <PromotionPaymentPopup
            handleClose={handleCloseFormFreePromotion}
            handleSubmit={handleApplyPromotion}
            initialValues={initialValues}
            open={openFormFreePromotion}
            promotionPrograms={promotionPrograms}
          />
        )}
      </>
    );
  },
);

const DialogError = observer(({ patientId, setFieldValue }) => {
  const { openConfirmMessage, handleCloseConfirmMessage } =
    useStore().feeStore.serviceFeeTabStore;
  return (
    <>
      {!!openConfirmMessage && (
        <ConfirmPopup
          open={!!openConfirmMessage}
          onClose={() => {
            handleCloseConfirmMessage(null);
            // khi đóng popup thì reset lại ngày lập
            setFieldValue("voucherDate", new Date());
          }}
          text={openConfirmMessage}
          onConfirm={() => {
            const url =
              Config.ROOT_PATH +
              PathModule.PATIENT_MANAGEMENT +
              `/patient-general?patientId=${patientId}`;

            window.open(url, "_blank");
          }}
          textConfirm={"Thông tin khách"}
          textClose={"Quay lại"}
          title="Thao tác thất bại"
          isNotAPromise
        />
      )}
    </>
  );
});

const DialogConfirmPromotion = observer(({ setFieldValue }) => {
  const [confirm, setConfirm] = useState(false);
  return (
    <>
      <Tooltip title="Bỏ chương trình khuyến mãi">
        <div
          onClick={() => {
            setConfirm(true);
          }}
          className="flex-center"
        >
          <IconCancel className="ml-2" color="red" />
        </div>
      </Tooltip>
      {!!confirm && (
        <ConfirmPopup
          open={!!confirm}
          onClose={() => {
            setConfirm(false);
          }}
          text={"Bạn có chắc chắn bỏ chương trình khuyến mãi này không ?"}
          onConfirm={() => {
            setFieldValue("promotionProgramId", null);
            setFieldValue("promotionProgramCode", null);
          }}
          textConfirm={"Đồng ý"}
          textClose={"Quay lại"}
          title="Bỏ chương trình khuyến mãi"
          isNotAPromise
        />
      )}
    </>
  );
});

export default memo(observer(ServiceFeePopup));
